import { render, staticRenderFns } from "./dismiss_button.vue?vue&type=template&id=2eb1b2c6&"
import script from "./dismiss_button.vue?vue&type=script&lang=js&"
export * from "./dismiss_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports